import React from 'react';

import { TextField as DSTextField, TextFieldProps as DSTextFieldProps } from '@lumx/react';

import { GLOBAL, useTranslate } from '@lumapps/translations';

/** Text field props */
export interface TextFieldProps extends DSTextFieldProps {}

/**
 * LumApps wrapper around the DS TextField.
 *
 * Adds an opinionated default `charCounterMessage` translation.
 *
 * @family Inputs
 */
export const TextField = React.forwardRef<HTMLDivElement, TextFieldProps>((props, ref) => {
    const { translateAndReplace, pluralize } = useTranslate();

    // Remaining character counter label
    const defaultCharCounterMessage: DSTextFieldProps['charCounterMessage'] = React.useMemo(
        () => (count) => translateAndReplace(pluralize(GLOBAL.NB_REMAINING, count), { NB: count }),
        [translateAndReplace, pluralize],
    );
    const charCounterMessage = props.charCounterMessage ?? defaultCharCounterMessage;

    return <DSTextField ref={ref} {...props} charCounterMessage={charCounterMessage} />;
}) as typeof DSTextField;
